export interface gbTags {
  google_signin?: string
  fb_app?: string
  title?: string
  image?: string
  url?: string
  type?: string
  description?: string
}
export interface gbTag {
  property: string
  content: string | undefined
}

export enum UseTagsEnum {
  Default = 'default',
  Auction = 'auction',
  Item = 'item',
  Items = 'items',
  EventTicket = 'eventTicket',
  EventTickets = 'eventTickets',
  Register = 'register',
  Login = 'login',
}
